import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const Hero = () => {
  const slides = [
    {
      title: "BUSINESS FORMAL",
      text: [
        "Tailored for Boardrooms & Beyond.",
        "Suits, blazers, dress shirts, skirts & trousers.",
        "Sharp cuts, premium fabrics, custom branding.",
      ],
      title2: "Project Professionalism With Confidence",
      images: [
        [
          "https://i.pinimg.com/564x/8d/3f/72/8d3f720e3bb91397dfc2a3acf96b976f.jpg",
          "https://t3.ftcdn.net/jpg/03/34/79/68/360_F_334796865_VVTjg49nbLgQPG6rgKDjVqSb5XUhBVsW.jpg",
        ],
        [
          "https://images.prodirectsport.com/ProductImages/Main/216487_Main_Thumb_0641438.jpg",
          "https://www.ottostore.com/cdn/shop/files/OTTOXDQ_138copypo_500x.jpg?v=1743770421",
        ],
        [
          "https://images.unsplash.com/photo-1617114919297-3c8ddb01f599?fm=jpg&q=60&w=3000",
          "https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=500&q=80",
        ],
      ],
    },
    {
      title: "BUSINESS CASUAL",
      text: [
        "Smart, Comfortable, Everyday Wear.",
        "Polos, chinos, cardigan, casual blazers.",
        "Blended for comfort & corporate style.",
      ],
      title2: "Perfect Balance of Relaxed & Refined",
      images: [
        [
          "https://i.pinimg.com/564x/8d/3f/72/8d3f720e3bb91397dfc2a3acf96b976f.jpg",
          "https://t3.ftcdn.net/jpg/03/34/79/68/360_F_334796865_VVTjg49nbLgQPG6rgKDjVqSb5XUhBVsW.jpg",
        ],
        [
          "https://images.prodirectsport.com/ProductImages/Main/216487_Main_Thumb_0641438.jpg",
          "https://www.ottostore.com/cdn/shop/files/OTTOXDQ_138copypo_500x.jpg?v=1743770421",
        ],
        [
          "https://images.unsplash.com/photo-1617114919297-3c8ddb01f599?fm=jpg&q=60&w=3000",
          "https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=500&q=80",
        ],
      ],
    },
    {
      title: "Branded Corporate Wear",
      text: [
        "Your Brand, Worn with Pride.",
        "Logo polos, t-shirts, hoodies, caps.",
        "Custom embroidery & prints.",
      ],
      title2: "Transform Your Team Into Brand Ambassadors",
      images: [
        [
          "https://i.pinimg.com/564x/8d/3f/72/8d3f720e3bb91397dfc2a3acf96b976f.jpg",
          "https://t3.ftcdn.net/jpg/03/34/79/68/360_F_334796865_VVTjg49nbLgQPG6rgKDjVqSb5XUhBVsW.jpg",
        ],
        [
          "https://images.prodirectsport.com/ProductImages/Main/216487_Main_Thumb_0641438.jpg",
          "https://www.ottostore.com/cdn/shop/files/OTTOXDQ_138copypo_500x.jpg?v=1743770421",
        ],
        [
          "https://images.unsplash.com/photo-1617114919297-3c8ddb01f599?fm=jpg&q=60&w=3000",
          "https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=500&q=80",
        ],
      ],
    },
    {
      title: "INDUSTRY & SAFETY WEAR",
      text: [
        "Designed for Performance & Protection.",
        "Coveralls, hi-vis jackets, flame-retardant gear.",
        "Healthcare scrubs & lab coats.",
      ],
      title2: "Safety And Comfort Tailored For Every Industry",
      images: [
        [
          "https://i.pinimg.com/564x/8d/3f/72/8d3f720e3bb91397dfc2a3acf96b976f.jpg",
          "https://t3.ftcdn.net/jpg/03/34/79/68/360_F_334796865_VVTjg49nbLgQPG6rgKDjVqSb5XUhBVsW.jpg",
        ],
        [
          "https://images.prodirectsport.com/ProductImages/Main/216487_Main_Thumb_0641438.jpg",
          "https://www.ottostore.com/cdn/shop/files/OTTOXDQ_138copypo_500x.jpg?v=1743770421",
        ],
        [
          "https://images.unsplash.com/photo-1617114919297-3c8ddb01f599?fm=jpg&q=60&w=3000",
          "https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=500&q=80",
        ],
      ],
    },
    {
      title: "HOSPITALITY & SERVICE WEAR",
      text: [
        "Style Meets Functionality.",
        "Chef coats, aprons, waistcoats, reception uniforms.",
        "Durable fabrics with elegant designs.",
      ],
      title2: "Elevate Your Service Experience",
      images: [
        [
          "https://i.pinimg.com/564x/8d/3f/72/8d3f720e3bb91397dfc2a3acf96b976f.jpg",
          "https://t3.ftcdn.net/jpg/03/34/79/68/360_F_334796865_VVTjg49nbLgQPG6rgKDjVqSb5XUhBVsW.jpg",
        ],
        [
          "https://images.prodirectsport.com/ProductImages/Main/216487_Main_Thumb_0641438.jpg",
          "https://www.ottostore.com/cdn/shop/files/OTTOXDQ_138copypo_500x.jpg?v=1743770421",
        ],
        [
          "https://images.unsplash.com/photo-1617114919297-3c8ddb01f599?fm=jpg&q=60&w=3000",
          "https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=500&q=80",
        ],
      ],
    },
    {
      title: "EVENT & PROMOTIONAL APPAREL",
      text: [
        "Stand Out at Every Occasion.",
        "Custom event t-shirts, polos, jerseys.",
        "Special edition collections.",
      ],
      title2: "Memorable Apparel For Memorble Events",
      images: [
        [
          "https://i.pinimg.com/564x/8d/3f/72/8d3f720e3bb91397dfc2a3acf96b976f.jpg",
          "https://t3.ftcdn.net/jpg/03/34/79/68/360_F_334796865_VVTjg49nbLgQPG6rgKDjVqSb5XUhBVsW.jpg",
        ],
        [
          "https://images.prodirectsport.com/ProductImages/Main/216487_Main_Thumb_0641438.jpg",
          "https://www.ottostore.com/cdn/shop/files/OTTOXDQ_138copypo_500x.jpg?v=1743770421",
        ],
        [
          "https://images.unsplash.com/photo-1617114919297-3c8ddb01f599?fm=jpg&q=60&w=3000",
          "https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=500&q=80",
        ],
      ],
    },
    {
      title: "OUTERWEAR & ACCESSORIES",
      text: [
        "Corporate Essentials Beyond the Office.",
        "Jackets, fleece, sweaters, scarves.",
        "Bags, belts, and caps with branding.",
      ],
      title2: "Complete The Corporate Look In Every Season",
      images: [
        [
          "https://i.pinimg.com/564x/8d/3f/72/8d3f720e3bb91397dfc2a3acf96b976f.jpg",
          "https://t3.ftcdn.net/jpg/03/34/79/68/360_F_334796865_VVTjg49nbLgQPG6rgKDjVqSb5XUhBVsW.jpg",
        ],
        [
          "https://images.prodirectsport.com/ProductImages/Main/216487_Main_Thumb_0641438.jpg",
          "https://www.ottostore.com/cdn/shop/files/OTTOXDQ_138copypo_500x.jpg?v=1743770421",
        ],
        [
          "https://images.unsplash.com/photo-1617114919297-3c8ddb01f599?fm=jpg&q=60&w=3000",
          "https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=500&q=80",
        ],
      ],
    },
  ];

  return (
    <section className="relative w-full bg-[#F6AE1B] mt-28">
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop
        pagination={{ clickable: true }}
        className="w-full"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-center w-full px-4 sm:px-6 md:px-12 lg:px-20 py-12 sm:py-16 lg:py-20 min-h-[70vh]">
              {/* Left Content */}
              <div className="text-center md:text-left">
                <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-snug break-words max-w-xl mx-auto md:mx-0">
                  {slide.title}
                </h1>
                <div className="mt-6 text-gray-700 text-base sm:text-lg max-w-md sm:max-w-lg mx-auto md:mx-0 space-y-1">
                  {slide.text.map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>
                <p className="mt-5 text-gray-900 md:text-2xl sm:text-lg max-w-md sm:max-w-lg mx-auto md:mx-0 break-words">
                  {slide.title2}
                </p>
                
              </div>

              {/* Right Staggered Grid */}
              <div className="grid grid-cols-3 gap-4 w-full">
                {slide.images.map((column, colIndex) => (
                  <div key={colIndex} className="flex flex-col gap-4">
                    {column.map((imgSrc, imgIndex) => (
                      <img
                        key={imgIndex}
                        src={imgSrc}
                        alt={`Slide ${index} Img ${colIndex}-${imgIndex}`}
                        className="rounded-xl shadow-md w-full h-auto object-cover"
                      />
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>


    </section>
    
  );
};

export default Hero;
